import React, { useState } from 'react'
import PropTypes from 'prop-types'
import PrivateLayout from 'layouts/private'
import { InfoCircleIcon, MagazineIcon, MessengerIcon, PhoneCallbackIcon } from '../../icons'
import PreferencesModal from '../../modals/PreferencesModal'
import { formatCurrency } from 'data/helpers/currency'
import Accordion from '../../accordion'
import AccordionItem from '../../accordion/AccordionItem'
import ModalNavControl from '../../ModalNavControl'
import InviteFriendsModal from '../../InviteFriendsModal'
import MobileDestinationsModal from '../../mobile/MobileDestinationsModal'

const MainCustomerProfileModalSection = ({ logout, user, setModal, setModalOpen, setContents }) => {
  const [preferencesModalOpen, setPreferencesModalOpen] = useState(false)
  const [isMembershipOpen, setIsMembershipOpen] = useState(false)
  const [inviteFriendsModalOpen, setInviteFriendsModalOpen] = useState(false)
  const [destinationsModalOpen, setDestinationsModalOpen] = useState(false)

  return (
    <div className="antialiased">
      <h1 className="font-serif text-26 text-grey-800">Hello, {user?.first_name}!</h1>
      <div className="mt-40">

        {/* Desktop */}
        <div className="hidden lg:block">
          <ModalNavControl.Link text="Dashboard" href="/home" className="text-grey-800" />
          <div className="flex flex-col ml-21 mt-15 gap-14">
            <ModalNavControl.Link text="Inbox" href="/home/inbox" className="text-grey-700" />
            <ModalNavControl.Link text="My Wishlists" href="/home/wishlists" className="text-grey-700" />
            <ModalNavControl.Link text="My Bookings" href="/home/reservations" className="text-grey-700" />
          </div>
        </div>

        <div className="hidden mt-40 lg:block">
          <h2>Profile</h2>
          <div className="flex flex-col ml-21 mt-15 gap-14">
            <ModalNavControl.Button text="Personal Information" onClick={() => setContents('profile')} className="text-grey-700" />
            <ModalNavControl.Button text="Preferences & notifications" onClick={() => setPreferencesModalOpen(true)} className="text-grey-700" />
          </div>
        </div>

        {/* Mobile */}
        <div className="lg:hidden mb-15">
          <Accordion className>
            <AccordionItem title="My Account" style={{ container: 'focus:text-primary', items: '!px-0' }}>

              <div className="mb-30">
                <ModalNavControl.Link text="Dashboard" href="/home" className="text-grey-800" />
                <div className="flex flex-col ml-21 mt-15 gap-14">
                  <ModalNavControl.Link text="Inbox" href="/home/inbox" className="text-grey-700" />
                  <ModalNavControl.Link text="My Wishlists" href="/home/wishlists" className="text-grey-700" />
                  <ModalNavControl.Link text="My Bookings" href="/home/reservations" className="text-grey-700" />
                </div>
              </div>

              <h2 className="!text-grey-800">Profile</h2>
              <div className="flex flex-col ml-21 mt-15 gap-14">
                <ModalNavControl.Button text="Personal Information" onClick={() => setContents('profile')} className="text-grey-700" />
                <ModalNavControl.Button text="Preferences & notifications" onClick={() => setPreferencesModalOpen(true)} className="text-grey-700" />
              </div>
            </AccordionItem>
          </Accordion>
        </div>

        {/* Mobile Main Nav */}
        <div className="flex flex-col lg:hidden gap-15">

          <ModalNavControl.Button text="Destinations" className="text-grey-800" onClick={() => setDestinationsModalOpen(true)} />

          <ModalNavControl.Link text="Services" href="/services" className="text-grey-800" />

          <ModalNavControl.Link text="About" href="/about-us" className="text-grey-800" />

          <ModalNavControl.Button text="Membership & Rewards" onClick={() => setIsMembershipOpen(!isMembershipOpen)} className="text-grey-800" />
          {
            isMembershipOpen
            && <div className="mt-10 mb-20">
              <div className="flex flex-col ml-21 gap-14">
                <div className="flex justify-between">
                  <h3 className="text-grey">My Status: {user?.membership_type}</h3>
                  <ModalNavControl.Link text="Edit" href="/membership" className="underline text-primary group-focus:text-primary-active" />
                </div>
                <h3 className="font-bold text-grey-700">My credit: {formatCurrency(user?.credit)}€ </h3>
                <p className="text-14 text-grey-500">
                  You can use your loyalty credit towards your next trip with us. <span className="inline underline cursor-pointer text-grey-900 text-14" onClick={() => setInviteFriendsModalOpen(true)}>Get up to 500€ additional credit  by inviting your friends!</span>
                </p>
              </div>
            </div>
          }
        </div>
      </div>


      {/* Desktop Membership & Notifications */}
      <div className="hidden mt-40 lg:block">
        <h2>Membership & notifications</h2>
        <div className="flex flex-col ml-21 mt-15 gap-14">
          <div className="flex justify-between">
            <h3 className="capitalize text-grey">My Status: {user?.membership_type}</h3>
            <ModalNavControl.Link text="Edit" href="/membership" className="underline text-primary" />
          </div>
          <h3 className="font-medium text-grey-700">My credit: {formatCurrency(user?.credit)} </h3>
          <p className="text-14 text-grey-500">
            You can use your loyalty credit towards your next trip with us. <span className="underline cursor-pointer text-grey-900 text-14" onClick={() => setInviteFriendsModalOpen(true)}>Get up to 500€ additional credit  by inviting your friends!</span>
          </p>
        </div>
      </div>

      {/* Mobile Main Nav */}
      <div className="mt-20 lg:hidden">
        <ModalNavControl.Link text={<>Magazine <MagazineIcon /></>} href="/magazine" className="flex justify-between items-center text-grey-800 border-t border-grey-200 py-10 leading-[40px]" block={true}></ModalNavControl.Link>
      </div>

      <div className="lg:mt-37 text-grey-200">
        <hr />
      </div>
      <div className="flex flex-col mt-30 gap-15">
        <p className="font-medium uppercase text-12 lg:text-14">help & support</p>
        <ModalNavControl.Button text={<>Call Us<InfoCircleIcon className="mr-2" /></>} onClick={() => setModalOpen(true)} className="flex items-center justify-between cursor-pointer text-grey-750" />
        <ModalNavControl.Button text={<>Request a Callback<PhoneCallbackIcon /></>} onClick={() => setModal('callback')} className="flex items-center justify-between cursor-pointer text-grey-750" />
        <ModalNavControl.Button text={<>Send us a Message<MessengerIcon className="mr-2" /></>} onClick={() => setModal('general')} className="flex items-center justify-between cursor-pointer text-grey-750" />
      </div>
      <div className="mt-26 text-grey-200">
        <hr />
      </div>
      <div className="flex justify-center mt-24">
        <div className="text-primary">
          <PrivateLayout />
          <ModalNavControl.Button text="Sign out" onClick={logout} className="font-medium underline focus:text-primary-active" />
        </div>
      </div>

      <PreferencesModal
        isOpen={preferencesModalOpen}
        onClose={() => setPreferencesModalOpen(false)}
      />
      <InviteFriendsModal
        isOpen={inviteFriendsModalOpen}
        onClose={() => setInviteFriendsModalOpen(false)}
      />
      <MobileDestinationsModal isOpen={destinationsModalOpen} onClose={() => setDestinationsModalOpen(false)} />
    </div>

  )
}

MainCustomerProfileModalSection.propTypes = {
  setContents: PropTypes.func,
  logout: PropTypes.func,
  user: PropTypes.object,
  setModal: PropTypes.func,
  setModalOpen: PropTypes.func,
}

export default MainCustomerProfileModalSection
